import { render, staticRenderFns } from "./ac-tags-inline.vue?vue&type=template&id=356d7c24&"
import script from "./ac-tags-inline.vue?vue&type=script&lang=js&"
export * from "./ac-tags-inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports